<div>
  <div class="noPrint action-bar">
    <button mat-raised-button color="primary" (click)="printNow()">Print</button>
    <button mat-raised-button (click)="close()">Close</button>
  </div>

  <div id="print">
    <div class="challan-page">
      <ng-container *ngFor="let data of amounts">
        <div class="challan-box">

          <!-- TOP HEADER: Org info LEFT | Logo RIGHT -->
          <div class="challan-header">
            <div class="org-info">
              <p class="org-name" style="margin-left: 272px; margin-top: 12px;font-size: 14px;">हिंदुस्थान प्रकाशन
                संस्था</p>
              <p style="margin-left: 74px;">116-119, शिल्पीन सेंटर, पहिला मजला, गं. द. आंबेकर मार्ग,वडाळा, मुंबई - 400
                031 दूरध्वनी : 9967570531</p>
              <!-- <p style="margin-left: 72px;"></p> -->
            </div>
            <div class="logo-area">
              <img src="../../../assets/img/brand/red.png" alt="Vivek Logo" width="90"
                style="margin-top:-15px;height: 100px;">
            </div>
          </div>

          <!-- ADDRESS ROW: Address LEFT | Date RIGHT -->
          <div class="address-row">
            <div class="address-block">
              <p>प्रति ,</p>
              <p><strong>{{ data.name }}</strong></p>
              <p>{{ data.address }}</p>
              <p>{{ data.pincode }} {{ data.taluka }}</p>
              <p>{{ data.mobile }}</p>
            </div>
            <div class="date-block">
              <p><strong>दिनांक :</strong> {{ vitarandate | date : "dd-MM-yyyy"}}</p>
            </div>
          </div>

          <!-- TABLE -->
          <table class="challan-table">
            <thead>
              <tr>
                <th>अंक संख्या</th>
                <th>रक्कम</th>
                <th>गणीबंडल</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ data.amount }}</td>
                <td>{{ data.amount * price }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <!-- SIGNOFF -->
          <div class="signoff">
            <p>(वर्गणी व विक्री विभाग)</p>
          </div>

          <!-- FOOTER -->
          <div class="challan-footer">
            <p><strong>मुख्य कार्यालय :</strong> 12, कामत औद्योगिक वसाहत, 316, स्वा. वीर सावरकर मार्ग, प्रभादेवी, मुंबई
              - 400025</p>
            <p>E-mail : vivekwklvargani&#64;gmail.com &nbsp;•&nbsp; Website : www.vivek.com</p>
          </div>

        </div>
      </ng-container>
    </div>
  </div>
</div>